import { useSelector } from 'react-redux';
import { InputTheme } from 'components/common/types/Input.types';
import { Store } from 'components/common/types/Store.types';
import { getLineLevelCpmSettings } from 'components/pages/DealWithLines/common/Main/Deal/selectors';
import ToggleSwitch, { ToggleTheme } from 'lib/ToggleSwitch';
import { Label } from 'lib/Label';
import usePendoTracking from 'customHooks/usePendoTracking';
import { useLineCPM } from './useLineCPM';

const LineCPMSwitch: React.FC = () => {
  const { getPendoDataId } = usePendoTracking();

  const isCpmCampaignLevel = useSelector((state: Store) => state.dealManagement.isCpmCampaignLevel);
  const { isLineLevelCpmVisible, isLineLevelCpmEditable } = useSelector(getLineLevelCpmSettings);

  const { onCpmCampaignLevelChange } = useLineCPM();

  return isLineLevelCpmVisible ? (
    <div className="flex justify-between items-center h-8">
      <Label id="Toggle for CPM line" theme={InputTheme.FLAT_GRAY} label="Apply CPM at deal line" />
      <ToggleSwitch
        id="Toggle for CPM line"
        theme={ToggleTheme.SMALL_LIGHT}
        onChange={onCpmCampaignLevelChange}
        isChecked={!isCpmCampaignLevel}
        isDisabled={!isLineLevelCpmEditable}
        dataPendoId={getPendoDataId(isCpmCampaignLevel ? 'Campaign level CPM' : 'Line level CPM')}
      />
    </div>
  ) : null;
};

export default LineCPMSwitch;
